module.exports = __webpack_public_path__ + "static/media/people3-min.656e0eb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/people3-min.png
// module id = 452
// module chunks = 0